module.exports = __webpack_public_path__ + "static/media/carousel5.85af919c.png";